import {DateFilterOptionNew} from './enums';
import {NewDateFilterType} from 'src/dtos/date-filter-type.dto';

export const EXTERNAL_USER_SOURCE = 'CUSTOMER';
export const INTERVAL_POLLING = 20000;
export const SERVICE_STATUS_POLLING = 60000;
export const DEVICES_POLLING = 30000;

export const ADMIN_ROLE = 'admin';
export const READ_USER_ROLE = 'ro';
export const ATT_SOURCE = 'ATT';
export const CUSTOM_TIME_RANGE = 'Custom';
export const LOADER_MINIMUM_MS = 850;

export const TOOLTIP_CONTENT_SPECIFIC_DAY = 'Select a custom day for all reports';
export const TOOLTIP_CONTENT_SPECIFIC_WEEK = 'Select a custom week for all reports';

export const defaultDateFilterPreferences: NewDateFilterType = { dateFilterOption: DateFilterOptionNew.LastTwentyFourHours, startDate: '' };

export const appLogoWrapperClassName = 'app-logo-wrapper';
export const reportItemClassName = 'report-item';
export const collapseButtonClassName = 'collapse-button';
export const tryAgainClassName = 'try-again-message';
export const lineChartClassName = 'line-chart-container';
export const dynamicListClassName = 'dynamic-list-wrapper';

export const IsNotificationTooltipShowedKey = 'isNotificationTooltipShowed';
export const IsDraftVersionTooltipShowedKey = 'isDraftVersionTooltipShowed';

export const MAINTENANCE_ALERT = 'Your draft policy currently can’t be applied due to maintenance activity.';
export const MAX_APPS = 200;
export const VIEW_ONLY_DISABLED_TOOLTIP_TEXT = 'You do not have permission to edit this item';
export const BRONZE_MAINTENANCE_DISABLED_TOOLTIP_TEXT = `Your policy currently can't be changed due to maintenance activity.`;

export const EXPERT_VIEW_MODAL_FIREWALL = 'ignoreExpertViewModalFirewall';
export const EXPERT_VIEW_MODAL_LIBRARY = 'ignoreExpertViewModalLibrary';

export const LAST_VISITED_PROTECTION_TAB = 'lastVisitedProtectionTab';

export const PUSH_POLICY_BATCH_ID = 'pushPolicyBatchId';

export const REPORTS_DATE_RANGE = 'reportsDateRange';

// Premier hands users off at /?stubId=<id>; parked in sessionStorage until the login redirect.
export const STUB_ID_QUERY_PARAM = 'stubId';
export const STUB_ID_KEY = 'premier.stubId';

export const selectFitPositionWithScroll = (trigger: any) => trigger.parentNode;
export const calcActionDuration = (startTime: number) => +(performance.now() - startTime).toFixed(2);

export const NOTIFICATION_TEXT = 'This is where all your notifications are shown for system activity and events.';

export const APPS_RECOMMENDED_NOTIFICATION_TEXT = 'You can now see policy recommendations under “Tips” in the notification panel';

export const APPS_RECOMMENDATION_TOOLTIP_SHOWED = 'policyRecommendationTooltipShowed';

export const DNS_DISABLE_ANTISPYWARE_INACTIVE = 'DNS Protection can be activated only when Spyware Protection is active';
export const DNS_DISABLE_ANTISPYWARE_HAS_INACTIVE = `${DNS_DISABLE_ANTISPYWARE_INACTIVE} on all default rules`;

export const MAX_ADDRESSES_LIMIT = 750;

export const MAX_BRONZE_IP_ADDRESSES = 10;
export const MAX_BRONZE_DOMAINS = 50;
export const MAX_REGISTERED_DEVICES = 20;
// Standard timeout (ms) for auto-clearing transient UI states (status messages, errors, etc.)
export const AUTO_CLEAR_TIMEOUT_MS = 10000;
export const CUSTOMER_SERVICE_ERROR_SOURCE = '"errorSource":"CUSTOMER_SERVICE"';
export const UNITED_STATES = 'United States';
export const PENDING_DISABLE_REASON = 'Can\'t create a draft while the current policy is pending';

/** localStorage key — marks the one-time Policy Settings onboarding popup as seen */
export const POLICY_SETTINGS_POPUP_SEEN = 'policySettingsPopupSeen';
